// extracted by mini-css-extract-plugin
module.exports = {"spl_bull_list":"STstyle_spl_bull_list__h4rC9","LBStructured":"STstyle_LBStructured__6xd38","ritualHeading":"STstyle_ritualHeading__lWqvO"};